export default "__VITE_ASSET__TqszcPlX__"